<div class="contact-page">
  <div class="page-container">
    <!-- Header -->
    <div class="page-header">
      <h1 class="page-title">¿Cómo podemos ayudarte?</h1>
      <p class="page-subtitle">
        Si tienes dudas sobre oportunidades o liquidaciones, contacta directamente con tu gestor
        asociado de SDI.
      </p>
    </div>

    <!-- Contact Card -->
    @if (isProfileLoading) {
      <div class="manager-card animate-pulse">
        <div class="h-4 w-32 bg-gray-200 dark:bg-gray-700 rounded mb-6"></div>

        <div class="manager-info">
          <div class="manager-avatar-wrapper">
            <div class="h-16 w-16 bg-gray-200 dark:bg-gray-700 rounded-full"></div>
          </div>

          <div class="manager-details flex-1">
            <div class="h-6 w-48 bg-gray-200 dark:bg-gray-700 rounded mb-2"></div>
            <div class="h-4 w-32 bg-gray-200 dark:bg-gray-700 rounded"></div>
          </div>
        </div>

        <div class="manager-contact-info mt-6 space-y-3">
          <div class="flex items-center gap-3">
            <div class="h-5 w-5 bg-gray-200 dark:bg-gray-700 rounded-full"></div>
            <div class="h-4 w-64 bg-gray-200 dark:bg-gray-700 rounded"></div>
          </div>
          <div class="flex items-center gap-3">
            <div class="h-5 w-5 bg-gray-200 dark:bg-gray-700 rounded-full"></div>
            <div class="h-4 w-40 bg-gray-200 dark:bg-gray-700 rounded"></div>
          </div>
        </div>
      </div>
    } @else if (sdiContact) {
      <div class="manager-card">
        <p class="manager-label">TU CONTACTO DEDICADO</p>

        <div class="manager-info">
          <div class="manager-avatar-wrapper">
            <div class="manager-avatar">
              {{ sdiContact.name.charAt(0).toUpperCase() || 'S' }}
            </div>
            <div class="status-indicator online"></div>
          </div>

          <div class="manager-details">
            <h3 class="manager-name">{{ sdiContact.name }}</h3>
            <p class="manager-title">
              Disponible para ayudarte con tus dudas sobre la plataforma, oportunidades o procesos
              de liquidación.
            </p>
          </div>

          <!-- <div class="manager-actions">
            <button type="button" (click)="openMessageForm()" class="btn btn-primary btn-with-icon">
              <fa-icon [icon]="faCalendar"></fa-icon>
              Agendar Reunión
            </button>
          </div> -->
        </div>

        <div class="manager-contact-info">
          <div class="contact-item">
            <fa-icon [icon]="faEnvelope" class="contact-icon"></fa-icon>
            <a [href]="'mailto:' + sdiContact.email" class="contact-link">{{ sdiContact.email }}</a>
          </div>

          @if (sdiContact.phone) {
            <div class="contact-item">
              <fa-icon [icon]="faPhone" class="contact-icon"></fa-icon>
              <a [href]="'tel:' + sdiContact.phone" class="contact-link">{{ sdiContact.phone }}</a>
            </div>
          }
        </div>
      </div>
    }

    <!-- Message Form (collapsible) -->
    <form [formGroup]="contactForm" (ngSubmit)="onSubmit()" class="message-form">
      <h3 class="form-title">Enviar Mensaje</h3>

      <div class="form-group">
        <label for="subject">Asunto</label>
        <input
          type="text"
          id="subject"
          placeholder="¿En qué podemos ayudarte?"
          formControlName="subject"
          [class.invalid]="f['subject'].invalid && f['subject'].touched"
        />
        @if (f['subject'].invalid && f['subject'].touched) {
          <div class="error-text">
            @if (f['subject'].errors?.['required']) {
              <span>El asunto es obligatorio</span>
            }
            @if (f['subject'].errors?.['minlength']) {
              <span>El asunto debe tener al menos 3 caracteres</span>
            }
          </div>
        }
      </div>

      <div class="form-group">
        <label for="message">Mensaje</label>
        <textarea
          id="message"
          placeholder="Escribe tu mensaje aquí..."
          formControlName="message"
          rows="6"
          [class.invalid]="f['message'].invalid && f['message'].touched"
        ></textarea>
        @if (f['message'].invalid && f['message'].touched) {
          <div class="error-text">
            @if (f['message'].errors?.['required']) {
              <span>El mensaje es obligatorio</span>
            }
            @if (f['message'].errors?.['minlength']) {
              <span>El mensaje debe tener al menos 10 caracteres</span>
            }
          </div>
        }
      </div>

      <div class="form-actions">
        <button
          type="submit"
          class="app-btn app-btn--primary"
          [disabled]="isLoading || contactForm.invalid"
        >
          <fa-icon [icon]="faPaperPlane" class="mr-2"></fa-icon>
          {{ isLoading ? 'Enviando...' : 'Enviar Mensaje' }}
        </button>
      </div>
    </form>
  </div>
</div>
